import { useMutation } from '@tanstack/react-query';

import { ClientPublicService } from '../../app/api/ClientPublicService';
import API from '../../app/api/api';

export const useContactTechnicalSupportMutation = () =>
  useMutation({
    mutationFn: (body?: ClientPublicService.ContactSupportFormDto) => API.contactSupport(body),
  });
